module.exports = __webpack_public_path__ + "img/20220312_144538.4473f077.jpg";